import { Trans } from '@lingui/react/macro';
import { DocumentRequirement } from 'components/Signup/TradingHistory/DocumentRequirement/DocumentRequirement';
import { TOfferDataRequirement } from 'lendingApi/lapiOverrides.types';
import sharedStyles from '../DocumentRequirements.module.css';

type TProps = {
  isOptional: boolean;
  isSubmitted: boolean;
  status?: TOfferDataRequirement['actions'][number]['status'];
};
export const BwaSusa = ({ isOptional, isSubmitted, status }: TProps) => {
  return (
    <DocumentRequirement
      title={
        <>
          <Trans>Current BWA and SuSa</Trans>
          <span className={sharedStyles.condition}>
            (<Trans>not older than 4 months</Trans>)
          </span>
        </>
      }
      documentType="management and balance accounts"
      isOptional={isOptional}
      isSubmitted={isSubmitted}
      status={status}
    >
      <ul>
        <li>
          <Trans>
            You can download BWA & SuSa from your accounting software or ask
            your tax advisor
          </Trans>
        </li>
        <li>
          <Trans>
            As an alternative, we also accept full annual financial statements
          </Trans>
        </li>
      </ul>
    </DocumentRequirement>
  );
};
